/** @jsx jsx */
import { jsx, css } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import { useEffect } from 'react';

import 'mapbox-gl/dist/mapbox-gl.css';
import useMap from '../../hooks/useMap';
import { useMapContext } from '../../contexts/mapContext';
import useSizeProperty from 'widgets/choroplethMap/hooks/useSizeProperty';
import useChoroplethHooks from 'widgets/choroplethMap/hooks/choropleth/useChoroplethHooks';
import Modal from './Modal';
import Legend from './Legend';
import { useChoroplethContext } from 'widgets/choroplethMap/contexts/choroplethContext';

export const ChoroplethMapWidget = ({
	data, // geojson object
	endpointQuery,
}) => {
	const [{ mapRef }] = useMapContext();
	const { setChoroplethData } = useChoroplethContext()[1];

	useEffect(() => {
		setChoroplethData(Object.assign({}, data));
	}, [setChoroplethData, data]);

	useSizeProperty({ endpointQuery });
	useMap();

	//CHOROPLETH
	useChoroplethHooks();

	return (
		<div css={wrapperStyle}>
			<div css={mapStyle} ref={mapRef} />
			<Modal />
			<Legend />
		</div>
	);
};

const mapStyle = css`
	flex: 1;
	height: 100%;
`;

const wrapperStyle = css`
	width: 100%;
	height: 100%;
	position: relative;
`;
